import { z } from 'zod';

// Schema for Python AST parsing response
const MethodInfoSchema = z.object({
  name: z.string(),
  async: z.boolean(),
  signature: z.string(),
  startLine: z.number(),
  endLine: z.number(),
  calls: z.array(z.string()),
});

const CodeNodeSchema = z.object({
  type: z.enum(['function', 'class']),
  name: z.string(),
  exported: z.boolean(),
  startLine: z.number(),
  endLine: z.number(),
  async: z.boolean().optional(),
  signature: z.string().optional(),
  calls: z.array(z.string()).optional(),
  methods: z.array(MethodInfoSchema).optional(),
});

const ImportInfoSchema = z.object({
  source: z.string(),
  imported: z.string(),
  alias: z.string().optional().nullable(),
});

export const ParsePythonResultSchema = z.object({
  nodes: z.array(CodeNodeSchema),
  imports: z.array(ImportInfoSchema),
});

export type ParsePythonResult = z.infer<typeof ParsePythonResultSchema>;

/**
 * Validates a Python AST parsing response from Python bridge.
 * Throws ZodError if the response doesn't match the expected schema.
 *
 * @param data - Raw data from Python bridge
 * @returns Validated ParsePythonResult
 * @throws {z.ZodError} If validation fails
 */
export function validateParsePythonResult(data: unknown): ParsePythonResult {
  return ParsePythonResultSchema.parse(data);
}
